import DeleteIcon from "@mui/icons-material/Delete";
import {useMandantenHandling} from "../../hooks/mandanten/useMandantenHandling";
import {bindPopover, bindTrigger, usePopupState} from "material-ui-popup-state/hooks";
import {
    Button,
    capitalize,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton
} from "@mui/material";

interface ButtonDeleteMandantProps {
    mandantId: string;
}

export default function ButtonDeleteMandant({mandantId}: ButtonDeleteMandantProps) {
    const {translation, deleteMandantMutation} = useMandantenHandling();
    const popupState = usePopupState({
        variant: 'popover',
        popupId: `mandant-${mandantId}-delete`,
    });

    return (
        <>
            <IconButton id={`button-delete-mandant-${mandantId}`}
                        aria-label={`button-delete-mandant-${mandantId}`}
                        {...bindTrigger(popupState)}
            >
                <DeleteIcon/>
            </IconButton>
            <Dialog id={`dialog-delete-mandant-${mandantId}`}
                    {...bindPopover(popupState)}
            >
                <DialogTitle id={`dialog-title-delete-mandant-${mandantId}`}>
                    {capitalize(translation('delete-dialogue-title'))}
                </DialogTitle>
                <DialogContent id={`dialog-content-delete-mandant-${mandantId}`}>
                    <DialogContentText id={`dialog-content-text-delete-mandant-${mandantId}`}>
                        {capitalize(translation('delete-dialogue-description'))}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button id={`dialog-action-cancel-delete-mandant-${mandantId}`}
                            color={'inherit'}
                            onClick={() => popupState.close()}
                    >
                        {capitalize(translation('abort'))}
                    </Button>
                    <Button id={`dialog-action-confirm-delete-mandant-${mandantId}`}
                            color={'error'}
                            variant={'contained'}
                            onClick={() => {
                                deleteMandantMutation.mutate(mandantId);
                                popupState.close();
                            }}
                    >
                        {capitalize(translation('delete'))}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

